// API Base URLs (VITE_STUDIO_API_URL is the canonical studio API origin in .env)
export const API_ENDPOINTS = {
  STUDIO_BACKEND:
    import.meta.env.VITE_STUDIO_API_URL ||
    import.meta.env.VITE_STUDIO_BACKEND_URL ||
    'http://localhost:3004',
  /** POST: Test Bot panel server-side HTTP proxy (under /api/bots so it matches the same routes as the rest of the studio API). */
  TEST_BOT_HTTP_PROXY_PATH: '/api/bots/test-flow-http-proxy',
  CHAT_ENGINE: import.meta.env.VITE_CHAT_ENGINE_URL || 'http://localhost:3003',
  IO_HANDLER: import.meta.env.VITE_IO_HANDLER_URL || 'http://localhost:3002',
  KNOWLEDGE_BASE: import.meta.env.VITE_KNOWLEDGE_BASE_URL || 'http://localhost:7003',
  
  // Studio API paths
  STUDIO: {
    AUTH: '/api/auth',
    BOTS: '/api/bots',
    TENANTS: '/api/tenants',
    USERS: '/api/users',
    CHANNELS: '/api/channels',
    ACTIONS: '/api/actions',
    ANALYTICS: '/api/analytics',
    LOGS: '/api/logs',
    SKILLS: '/api/skills',
    TICKETS: '/api/tickets',
    ANNOUNCEMENTS: '/api/announcements',
    INTERNAL_CHAT: '/api/internal-chat',
    NOTIFICATIONS: '/api/notifications',
    PLATFORM_SETTINGS: '/api/platform-settings',
  },
};

